import { Credential } from "../credentials/credential";
import { Specialty } from "../specialties/specialty";

const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Provider {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  namePrefix: string;
  nameSuffix: string;
  dob: string;
  credentialSuffix: string;
  gender: string;
  mailingAddress1: string;
  mailingAddress2: string;
  mailingCity: string;
  mailingState: string;
  mailingZip: string;
  phone1: string;
  phone2: string;
  stateLicenseNumber: string;
  stateLicenseExpiration: string;
  stateLicensed: string;
  npIdentificationNumber: string;
  prescriptiveAuthorityExpiration: string;
  rxAuthorizationNumber: string;
  medicalBio: string;
  specialties: any;
  credentials: any;
  signatureElectronic: string;
  status: boolean;
  signatureDate: string;
  createdDate: string;
  updatedDate: string;

  constructor(providerInfo: any) {
    providerInfo = camelcaseKeysDeep(providerInfo);

    this.id = providerInfo.id;
    this.firstName = providerInfo.firstName;
    this.middleName = providerInfo.middleName;
    this.lastName = providerInfo.lastName;
    this.namePrefix = providerInfo.namePrefix;
    this.nameSuffix = providerInfo.nameSuffix;
    this.dob = providerInfo.dob;
    this.credentialSuffix = providerInfo.credentialSuffix;
    this.gender = providerInfo.gender;
    this.mailingAddress1 = providerInfo.mailingAddress1;
    this.mailingAddress2 = providerInfo.mailingAddress2;
    this.mailingCity = providerInfo.mailingCity;
    this.mailingState = providerInfo.mailingState;
    this.mailingZip = providerInfo.mailingZip;
    this.phone1 = providerInfo.phone1;
    this.phone2 = providerInfo.phone2;
    this.stateLicenseNumber = providerInfo.stateLicenseNumber;
    this.stateLicenseExpiration = providerInfo.stateLicenseExpiration;
    this.stateLicensed = providerInfo.stateLicensed;
    this.npIdentificationNumber = providerInfo.npIdentificationNumber;
    this.prescriptiveAuthorityExpiration = providerInfo.prescriptiveAuthorityExpiration;
    this.rxAuthorizationNumber = providerInfo.rxAuthorizationNumber;
    this.medicalBio = providerInfo.medicalBio;
    this.specialties = providerInfo.specialties && providerInfo.specialties.map((specialty) => {
      if (specialty && typeof (specialty) === 'object') {
        return new Specialty(specialty);
      } else {
        return new Specialty({ id: specialty });
      }
    });
    this.credentials = providerInfo.credentials && providerInfo.credentials.map((credential) => {
      if (credential && typeof (credential) === 'object') {
        return new Credential(credential);
      } else {
        return new Credential({ id: credential });
      }
    });

    this.signatureElectronic = providerInfo.signatureElectronic;
    this.status = providerInfo.status;
    this.signatureDate = providerInfo.signatureDate;
    this.createdDate = providerInfo.createdDate;
    this.updatedDate = providerInfo.updatedDate;
  }

  get name(): string {
    return this.firstName + ' ' + this.lastName;
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/provider.ts